import "./suggestions.scss"
import { useContext, useState } from "react";
import { useQuery } from '@tanstack/react-query';
import { makeRequest } from "../../axios";
import { AuthContext } from "../../context/authContext";
import Suggestion from "../suggestion/Suggestion";


const Suggestions = () => {
  const {currentUser} = useContext(AuthContext);
  const userId = currentUser.id
  const [suggestions, setSuggestions] = useState(null);


  const { isLoading, error, data } = useQuery(["suggestions"], () =>
    makeRequest.get("/suggestions?userId=" + userId).then((res) => {
      let result = Object.values(JSON.parse(JSON.stringify(res.data)))
      setSuggestions(result)
      return result;
    })
  );

  return (
    <div className="notSure">
      {error
        ? "Something went wrong!" + error
        : isLoading
        ? "loading"
        : <Suggestion unfollowedUsers={suggestions}/>
      }
    </div>
  );
};

export default Suggestions;
